import { useShallow } from "zustand/react/shallow";
import { useSearchParams } from "react-router-dom";

import Toggle from "ds/components/Toggle";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageResources } from "hooks/useAnalytics/pages/resources";
import useTypedFlags from "hooks/useTypedFlags";

import { useResourcesUiSwitchStore } from "../useResourcesUiSwitchStore";

type ResourcesUiToggleProps = {
  page: AnalyticsPageResources;
};

const ResourcesUiToggle = ({ page }: ResourcesUiToggleProps) => {
  const { resourcesRedesign } = useTypedFlags();
  const [, setSearchParams] = useSearchParams();

  const trackAnalytics = useAnalytics({
    page,
  });

  const { isNewUiEnabled, setIsNewUiEnabled } = useResourcesUiSwitchStore(
    useShallow((state) => ({
      isNewUiEnabled: state.isNewUiEnabled,
      setIsNewUiEnabled: state.setIsNewUiEnabled,
    }))
  );

  const toggleNewUi = () => {
    // Reset search params when toggling the UI, filters are not compatible
    setSearchParams({});
    setIsNewUiEnabled(!isNewUiEnabled);
    trackAnalytics("UI Toggle Clicked", { isNewUIEnabled: !isNewUiEnabled });
  };

  if (!resourcesRedesign) {
    return null;
  }

  return (
    <Toggle
      variant="switch"
      typographyVariant="p-t7"
      isSelected={isNewUiEnabled}
      onChange={toggleNewUi}
    >
      New resources view
    </Toggle>
  );
};

export default ResourcesUiToggle;
